import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/Layout';
import DataTable from 'react-data-table-component';

import * as XLSX from 'xlsx';
import { del, get, post, put } from '../../controllers/apiController';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Select2 } from '../../components/Select2';

const Hizmetler = () => {
    const [originalHizmetler, setOriginalHizmetler] = useState([]);
    const [hizmetler, setHizmetler] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [search, setSearch] = useState("");
    const [isCreateModalOpen, setCreateModalIsOpen] = useState(false);
    const [isUpdateModalOpen, setUpdateModalIsOpen] = useState(false);

    const yesNoOptions = [
        {
            label: "Evet",
            value: "1"
        },
        {
            label: "Hayır",
            value: "0"
        }
    ];

    const [selectedHizmet, setSelectedHizmet] = useState(null);

    const [companyName, setCompanyName] = useState('');
    const [endDate, setEndDate] = useState('');
    const [hostingService, setHostingService] = useState(null);
    const [sslService, setSSLService] = useState(null);
    const [domainService, setDomainService] = useState(null);

    const paginationComponentOptions = {
        rowsPerPageText: 'Sayfa başına satır:',
        rangeSeparatorText: 'toplam',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Tümü',
        firstPageText: 'İlk',
        previousPageText: 'Önceki',
        nextPageText: 'Sonraki',
        lastPageText: 'Son',
        noRowsPerPage: false,
    };

    useEffect(() => {
        document.title = "Hizmetler | LEVELUP CRM";

        const fetchData = async () => {
            const res = await get("services/");

            setOriginalHizmetler(res);
            setHizmetler(res);

            setIsLoading(false);
        }

        try {
            fetchData();
        } catch (err) {
            toast.error("Veriler alınırken bir hata oluştu!");
        }
    }, []);

    useEffect(() => {
        let filtered = originalHizmetler;

        if (search) {
            filtered = filtered.filter(item =>
                item.Firma_Adi.toLowerCase().includes(search.toLowerCase())
            );
        }

        setHizmetler(filtered);
    }, [search, originalHizmetler]);

    function formatDateForInput(value) {
        if (!value) return '';
        const date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }      

    const handleSearch = (event) => {
        setSearch(event.target.value);
    };

    const handleDelete = async (serviceId) => {
        Swal.fire({
            icon: "warning",
            title: "Hizmet Silme",
            html: 'Hizmeti silmek istediğinize emin misiniz ? <b class="text-danger">(Bu işlem geri alınamaz)</b>',
            showCancelButton: true,
            confirmButtonText: "Sil",
            cancelButtonText: "İptal"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await del(`services/${serviceId}`);

                    setOriginalHizmetler((prevHizmetler) => {
                        return prevHizmetler.filter((service) => service.Hizmet_ID !== serviceId);
                    });

                    toast.success("Hizmet başarıyla silindi.");
                } catch (error) {
                    toast.error(error.response.data.message || "Hizmet silirken bir hata oluştu!");
                }
            }
        });
    }

    const customStyles = {
        noData: {
            style: {
                padding: '24px',
                textAlign: 'center',
            },
        },
        rows: {
            style: {
                padding: '20px 0',
            },
        },
        modalBackdropStyle: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1040
        }
    };

    const columns = [
        {
            name: 'FİRMA ADI',
            cell: row => (
                <a href={`./service-detail?id=${row.Hizmet_ID}`} className="hstack gap-3">
                    <div>
                        <span className="text-truncate-1-line">{row.Firma_Adi}</span>
                    </div>
                </a>
            ),
            sortable: true
        },
        {
            name: 'BİTİŞ TARİHİ',
            cell: row => {
                const tarih = new Date(row.Bitis_Tarihi);
                const formatliTarih = `${tarih.getDate().toString().padStart(2, '0')}.${(tarih.getMonth() + 1).toString().padStart(2, '0')}.${tarih.getFullYear()} ${tarih.getHours().toString().padStart(2, '0')}:${tarih.getMinutes().toString().padStart(2, '0')}`;
            
                const bugun = new Date();
                const farkMs = tarih - bugun;
                const farkGun = farkMs / (1000 * 60 * 60 * 24);
            
                const renkClass = farkGun < 15 ? "text-danger" : "";
            
                return <span className={`fw-semibold ${renkClass}`}>{formatliTarih}</span>;
            },            
            sortable: true
        },
        {
            name: 'HİZMETLER',
            cell: row => {
                const hizmetler = [];
                if (row.Hosting_Hizmeti == 1) hizmetler.push('Hosting');
                if (row.Domain_Hizmeti == 1) hizmetler.push('Domain');
                if (row.Ssl_Hizmeti == 1) hizmetler.push('SSL');
                return <span>{hizmetler.join(', ') || 'Yok'}</span>;
            },
            sortable: false
        },        
        {
            name: 'AKSİYON',
            cell: row => (
                <div className="d-flex gap-1">
                    <a href={`./service-detail?id=${row.Hizmet_ID}`} className="avatar-text avatar-md" data-bs-toggle="tooltip" data-bs-original-title="Detay">
                        <i className="feather feather-eye fs-6"></i>
                    </a>
                    <button onClick={(e) => openEditModal(row.Hizmet_ID)} className="text-primary avatar-text avatar-md" data-bs-toggle="tooltip" data-bs-original-title="Düzenle">
                        <i className="feather feather-edit fs-6"></i>
                    </button>
                    <button onClick={(e) => handleDelete(row.Hizmet_ID)} className="text-danger avatar-text avatar-md" data-bs-toggle="tooltip" data-bs-original-title="Sil">
                        <i className="feather feather-trash fs-6"></i>
                    </button>
                </div>
            )
        }
    ];

    const handleExport = () => {
        const data = hizmetler;

        const excelData = data.map(row => {
            return {
                'FİRMA ADI': row.Firma_Adi,
                'BİTİŞ TARİHİ': row.Bitis_Tarihi,
                'HOSTİNG HİZMETİ': row.Hosting_Hizmeti == 1 ? "Evet" : "Hayır",
                'SSL HİZMETİ': row.Ssl_Hizmeti == 1 ? "Evet" : "Hayır",
                'DOMAİN HİZMETİ': row.Domain_Hizmeti == 1 ? "Evet" : "Hayır"
            };
        });

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Hizmetler");

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Hizmetler_${new Date().toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(/\//g, '.').replace(':', '.')}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
    };

    const createService = async () => {
        if (companyName === "" || endDate === "" || hostingService === null || sslService === null || domainService === null) {
            toast.error("Tüm alanları doldurmalısınız!");
            return;
        }

        try {
            const response = await post("services/save", {
                companyName: companyName,
                endDate: endDate,
                hosting: parseInt(hostingService.value),
                ssl: parseInt(sslService.value),
                domain: parseInt(domainService.value)
            });

            setCompanyName("");
            setEndDate("");
            setHostingService(null);
            setSSLService(null);
            setDomainService(null);

            toast.success("Hizmet başarıyla eklendi!");
            window.location.reload();
        } catch (err) {
            toast.error("Hizmet oluşturulurken bir hata oluştu!");
        }
    }

    const openEditModal = async (serviceID) => {
        setSelectedHizmet(originalHizmetler.find(service => service.Hizmet_ID == serviceID));

        setUpdateModalIsOpen(true);
    }

    const updateService = async () => {
        if (selectedHizmet.Firma_Adi === "" || selectedHizmet.Bitis_Tarihi === "" || selectedHizmet.Hosting_Hizmeti === null || selectedHizmet.Ssl_Hizmeti === null || selectedHizmet.Domain_Hizmeti === null) {
            toast.error("Tüm alanları doldurmalısınız!");
            return;
        }

        try {
            const response = await put(`services/${selectedHizmet.Hizmet_ID}`, {
                companyName: selectedHizmet.Firma_Adi,
                endDate: selectedHizmet.Bitis_Tarihi,
                hosting: parseInt(selectedHizmet.Hosting_Hizmeti),
                ssl: parseInt(selectedHizmet.Ssl_Hizmeti),
                domain: parseInt(selectedHizmet.Domain_Hizmeti)
            });

            setOriginalHizmetler(prev =>
                prev.map(service =>
                    service.Hizmet_ID === selectedHizmet.Hizmet_ID ? { ...service, ...selectedHizmet } : service
                )
            );
    
            setHizmetler(prev =>
                prev.map(service =>
                    service.Hizmet_ID === selectedHizmet.Hizmet_ID ? { ...service, ...selectedHizmet } : service
                )
            );

            setUpdateModalIsOpen(false);

            toast.success("Hizmet başarıyla güncellendi!");
        } catch (err) {
            toast.error("Hizmet güncellenirken bir hata oluştu!");
        }
    }

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Hizmetler</li>
                            </ul>
                        </div>
                        <div className="page-header-right ms-auto">
                            <div className="page-header-right-items">
                                <div className="d-flex d-md-none">
                                    <a href="javascript:void(0)" className="page-header-right-close-toggle">
                                        <i className="feather-arrow-left me-2"></i>
                                        <span>Geri</span>
                                    </a>
                                </div>
                                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                                    <a href="javascript:void(0);" onClick={handleExport} className="btn btn-icon btn-light-brand">
                                        <i className="feather-printer"></i>
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-icon btn-light-brand collapsed" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false">
                                        <i className="feather-bar-chart"></i>
                                    </a>
                                </div>
                            </div>
                            <div className="d-md-none d-flex align-items-center">
                                <a href="javascript:void(0)" className="page-header-right-open-toggle">
                                    <i className="feather-align-right fs-20"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div id="collapseOne" className="accordion-collapse page-header-collapse collapse">
                        <div className="accordion-body pb-2">
                            <div className="row">
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <i className="feather-users"></i>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Toplam Hizmet</span>
                                                        <span className="fs-24 fw-bolder d-block">{hizmetler.length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <i className="feather-facebook"></i>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Toplam Hosting Hizmeti Sayısı</span>
                                                        <span className="fs-24 fw-bolder d-block">{hizmetler.filter(hizmet => hizmet.Hosting_Hizmeti == 1).length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M11.99 13.9v-3.72h9.36c.14.63.25 1.22.25 2.05c0 5.71-3.83 9.77-9.6 9.77c-5.52 0-10-4.48-10-10S6.48 2 12 2c2.7 0 4.96.99 6.69 2.61l-2.84 2.76c-.72-.68-1.98-1.48-3.85-1.48c-3.31 0-6.01 2.75-6.01 6.12s2.7 6.12 6.01 6.12c3.83 0 5.24-2.65 5.5-4.22h-5.51z" /></svg>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Toplam SSL Hizmeti Sayısı</span>
                                                        <span className="fs-24 fw-bolder d-block">{hizmetler.filter(hizmet => hizmet.Ssl_Hizmeti == 1).length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <i className="feather-globe"></i>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Toplam Domain Hizmeti Sayısı</span>
                                                        <span className="fs-24 fw-bolder d-block">{hizmetler.filter(hizmet => hizmet.Domain_Hizmeti == 1).length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-header d-flex align-items-center justify-content-between">
                                        <div className="col-7 col-xs-6">
                                            <h5 className="card-title">Tüm Hizmetler</h5>
                                        </div>
                                        <div className="col-5 col-xs-6 d-flex align-items-center gap-2">
                                            <input
                                                type="text"
                                                placeholder="Ara..."
                                                className="form-control w-75"
                                                value={search}
                                                onChange={handleSearch}
                                            />
                                            <button className="btn btn-light w-25" onClick={(e) => setCreateModalIsOpen(true)}>
                                                <i className="feather-plus"></i>
                                                Yeni Ekle
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body custom-card-action p-2">
                                        {isLoading ? (
                                            <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Yükleniyor...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="table-responsive mb-3">
                                                <DataTable
                                                    columns={columns}
                                                    data={hizmetler}
                                                    className="table table-hover mb-0"
                                                    pagination
                                                    responsive
                                                    noDataComponent="Görüntülenecek kayıt bulunamadı"
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    customStyles={customStyles}
                                                    paginationPerPage={10}
                                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {isCreateModalOpen && (
                        <div
                            className="modal show d-block"
                            tabIndex="-1"
                            role="dialog"
                            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                        >
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Hizmet Ekle</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setCreateModalIsOpen(false)}
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row mb-3 align-items-center">
                                            <label for="companyName" className="fw-semibold">Firma Adi: </label>
                                            <div style={{ flex: 1 }}>
                                                <input type="text" className="form-control" id="companyName" placeholder="Firma adını giriniz." onChange={(e) => setCompanyName(e.target.value)} value={companyName} />
                                            </div>
                                        </div>
                                        <div className="row mb-3 align-items-center">
                                            <label for="endDate" className="fw-semibold">Bitiş Tarihi: </label>
                                            <div style={{ flex: 1 }}>
                                                <input type="datetime-local" className="form-control" id="endDate" onChange={(e) => setEndDate(e.target.value)} value={endDate} />
                                            </div>
                                        </div>
                                        <div className="row mb-3 align-items-center">
                                            <label htmlFor="hostingSelect" className="fw-semibold">Hosting Hizmeti: </label>
                                            <div style={{ flex: 1 }}>
                                                <Select2
                                                    value={hostingService}
                                                    key={"hostingSelect"}
                                                    options={yesNoOptions}
                                                    isSearchable={false}
                                                    isClearable={false}
                                                    isMulti={false}
                                                    onChange={(e) => setHostingService(e)}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-3 align-items-center">
                                            <label htmlFor="sslSelect" className="fw-semibold">SSL Hizmeti: </label>
                                            <div style={{ flex: 1 }}>
                                                <Select2
                                                    value={sslService}
                                                    key={"sslSelect"}
                                                    options={yesNoOptions}
                                                    isSearchable={false}
                                                    isClearable={false}
                                                    isMulti={false}
                                                    onChange={(e) => setSSLService(e)}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-3 align-items-center">
                                            <label htmlFor="domainSelect" className="fw-semibold">Domain Hizmeti: </label>
                                            <div style={{ flex: 1 }}>
                                                <Select2
                                                    value={domainService}
                                                    key={"domainSelect"}
                                                    options={yesNoOptions}
                                                    isSearchable={false}
                                                    isClearable={false}
                                                    isMulti={false}
                                                    onChange={(e) => setDomainService(e)}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        </div>

                                        <div className="mt-3 d-flex justify-content-start">
                                            <button onClick={createService} className="btn btn-primary">
                                                <i className="feather-plus me-2"></i>
                                                <span>Hizmet Oluştur</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={() => setCreateModalIsOpen(false)}
                                        >
                                        Kapat
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {isUpdateModalOpen && (
                        <div
                            className="modal show d-block"
                            tabIndex="-1"
                            role="dialog"
                            style={{ backgroundColor: "rgba(43, 25, 25, 0.5)" }}
                        >
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Hizmet Güncelle</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setUpdateModalIsOpen(false)}
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row mb-3 align-items-center">
                                            <label for="companyName" className="fw-semibold">Firma Adi: </label>
                                            <div style={{ flex: 1 }}>
                                                <input type="text" className="form-control" id="companyName" placeholder="Firma adını giriniz." onChange={(e) => setSelectedHizmet(prev => ({ ...prev, Firma_Adi: e.target.value }))} value={selectedHizmet.Firma_Adi} />
                                            </div>
                                        </div>
                                        <div className="row mb-3 align-items-center">
                                            <label for="endDate" className="fw-semibold">Bitiş Tarihi: </label>
                                            <div style={{ flex: 1 }}>
                                                <input type="datetime-local" className="form-control" id="endDate" onChange={(e) => setSelectedHizmet(prev => ({ ...prev, Bitis_Tarihi: e.target.value }))} value={formatDateForInput(selectedHizmet.Bitis_Tarihi)} />
                                            </div>
                                        </div>
                                        <div className="row mb-3 align-items-center">
                                            <label htmlFor="hostingSelect" className="fw-semibold">Hosting Hizmeti: </label>
                                            <div style={{ flex: 1 }}>
                                                <Select2
                                                    defaultValue={selectedHizmet.Hosting_Hizmeti.toString()}
                                                    key={"hostingSelect"}
                                                    options={yesNoOptions}
                                                    isSearchable={false}
                                                    isClearable={false}
                                                    isMulti={false}
                                                    onChange={(e) => setSelectedHizmet(prev => ({ ...prev, Hosting_Hizmeti: e.value }))}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-3 align-items-center">
                                            <label htmlFor="sslSelect" className="fw-semibold">SSL Hizmeti: </label>
                                            <div style={{ flex: 1 }}>
                                                <Select2
                                                    value={selectedHizmet.Ssl_Hizmeti == 1 ? yesNoOptions[0] : yesNoOptions[1]}
                                                    defaultValue={selectedHizmet.Ssl_Hizmeti.toString()}
                                                    key={"sslSelect"}
                                                    options={yesNoOptions}
                                                    isSearchable={false}
                                                    isClearable={false}
                                                    isMulti={false}
                                                    onChange={(e) => setSelectedHizmet(prev => ({ ...prev, Ssl_Hizmeti: e.value }))}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-3 align-items-center">
                                            <label htmlFor="domainSelect" className="fw-semibold">Domain Hizmeti: </label>
                                            <div style={{ flex: 1 }}>
                                                <Select2
                                                    value={selectedHizmet.Domain_Hizmeti == 1 ? yesNoOptions[0] : yesNoOptions[1]}
                                                    defaultValue={selectedHizmet.Domain_Hizmeti.toString()}
                                                    key={"domainSelect"}
                                                    options={yesNoOptions}
                                                    isSearchable={false}
                                                    isClearable={false}
                                                    isMulti={false}
                                                    onChange={(e) => setSelectedHizmet(prev => ({ ...prev, Domain_Hizmeti: e.value }))}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        </div>

                                        <div className="mt-3 d-flex justify-content-start">
                                            <button onClick={updateService} className="btn btn-primary">
                                                <i className="feather-plus me-2"></i>
                                                <span>Kaydet</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={() => setUpdateModalIsOpen(false)}
                                        >
                                        Kapat
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main>
        </Layout>
    );
};

export default Hizmetler;
